import { render } from "./PropertyOwnerTermsConditionModal.vue?vue&type=template&id=9f6eddbc&ts=true"
import script from "./PropertyOwnerTermsConditionModal.vue?vue&type=script&lang=ts"
export * from "./PropertyOwnerTermsConditionModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__